export default __webpack_public_path__ + "static/media/IMG_20230719_133000 - muskan bidani.bd5ab1f6.jpg";